import { Injectable } from '@angular/core';
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private redirectUrl: string | null = null;
  private warningMessage: string | null = null;

  constructor( private router: Router,) {
  }

  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }

  redirectStoreUrl() {
    let  redirectUrl = this.redirectUrl;
    if(redirectUrl?.hasActualValue()){
      this.router.navigateByUrl(redirectUrl!).then(r =>
        this.clearRedirectUrl());
    }else{
      this.router.navigate(['/']).then()
    }

  }

  clearRedirectUrl(): void {
    this.warningMessage = ""
    this.redirectUrl = null;
  }

  setWarningMessage(message: string): void {
    this.warningMessage = message;
  }

  getWarningMessage(): string | null {
    return this.warningMessage;
  }

}
